import { ITutorialPassos, MensagensPadrao } from "../../../Components/AdicionarAjuda"

export const IDs = {
    formularioDeFiltro: "formulario-de-filtros-do-usuario",

    filtroDeNome: "campo-nome-filtros-do-usuario",
    filtroDeEmail: "campo-email-filtros-do-usuario",
    filtroDeUsuario: "campo-usuario-filtros-do-usuario",
    filtroDeAtivo: "campo-ativo-filtros-do-usuario",

    botaoListar: "botao-listar-usuarios",
    botaoAdicionar: "botao-adicionar-usuario",
}

export const Classes = {
    botaoEditar: "botao-editar-usuario",
    botaoDesativar: "botao-desativar-usuario",
}

export const ConsultarUsuario: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.filtros.apresentacao, target: () => document.getElementById(IDs.formularioDeFiltro)! },
        { ...MensagensPadrao.filtros.nome, target: () => document.getElementById(IDs.filtroDeNome)! },
        { ...MensagensPadrao.filtros.email, target: () => document.getElementById(IDs.filtroDeEmail)! },
        { ...MensagensPadrao.filtros.usuario, target: () => document.getElementById(IDs.filtroDeUsuario)! },
        { ...MensagensPadrao.filtros.ativo, target: () => document.getElementById(IDs.filtroDeAtivo)! },
        { ...MensagensPadrao.filtros.botaoListar, target: () => document.getElementById(IDs.botaoListar)! },
    ]
}

export const AdicionarUsuario: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.adicionar.entrada, target: () => document.getElementById(IDs.botaoAdicionar)! },
    ]
}

export const EditarUsuario: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.editar, target: () => document.querySelector('.' + Classes.botaoEditar)! },
    ]
}

export const DesativarUsuario: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.editar, target: () => document.querySelector('.' + Classes.botaoDesativar)! },
    ]
}
